{
  "Accessibility menu": "പ്രവേശയോഗ്യത മെനു",
  "Reset settings": "ക്രമീകരണങ്ങൾ പുനഃസജ്ജമാക്കുക",
  "Close": "അടയ്ക്കുക",
  "Content adjustments": "ഉള്ളടക്ക ക്രമീകരണങ്ങൾ",
  "Navigation adjustments": "നാവിഗേഷൻ ക്രമീകരണങ്ങൾ",
  "Align Left": "ഇടത് വിന്യസിക്കുക",
  "Adjust Font Size": "അക്ഷരത്തിന്റെ വലുപ്പം ക്രമീകരിക്കുക",
  "Highlight Title": "ശീർഷകം ഹൈലൈറ്റ് ചെയ്യുക",
  "Highlight Links": "ലിങ്കുകൾ ഹൈലൈറ്റ് ചെയ്യുക",
  "Readable Font": "വായിക്കാൻ എളുപ്പമുള്ള ഫോണ്ട്",
  "Colour adjustments": "നിറ ക്രമീകരണങ്ങൾ",
  "Dark Contrast": "ഇരുണ്ട കോൺട്രാസ്റ്റ്",
  "Light Contrast": "ഇളം കോൺട്രാസ്റ്റ്",
  "High Contrast": "ഉയർന്ന കോൺട്രാസ്റ്റ്",
  "High Saturation": "ഉയർന്ന സാചുരേഷൻ",
  "Low Saturation": "കുറഞ്ഞ സാചുരേഷൻ",
  "Monochrome": "മോനോക്രോം",
  "Tools": "ഉപകരണങ്ങൾ",
  "Reading Guide": "വായനാ ഗൈഡ്",
  "Stop Animations": "ആനിമേഷനുകൾ നിർത്തുക",
  "Big Cursor": "വലിയ കർസർ",
  "Increase Font Size": "ഫോണ്ട് വലുപ്പം വർദ്ധിപ്പിക്കുക",
  "Decrease Font Size": "ഫോണ്ട് വലുപ്പം കുറയ്ക്കുക",
  "Letter Spacing": "അക്ഷരങ്ങൾക്കിടയിലെ ഇടവ്",
  "Line Height": "ലൈൻ ഉയരം",
  "Font Weight": "ഫോണ്ട് ഭാരം",
  "Dyslexia Font": "ഡിസ്ലെക്സിയ ഫോണ്ട്",
  "Language": "ഭാഷ",
  "Accessibility widget": "പ്രവേശയോഗ്യത മെനു തുറക്കുക",
  "Accessibility Profiles": "പ്രവേശയോഗ്യത പ്രൊഫൈലുകൾ",
  "Cognitive Disability": "ജ്ഞാനപരമായ വൈകല്യം",
  "Seizure Safe": "അപസ്മാരത്തിന് സുരക്ഷിതം",
  "Accessibility statement": "പ്രവേശയോഗ്യത പ്രസ്താവന"
}
